<template>
  <div>
    <div class="submenu">
      <ul>
        <router-link tag="li" to="/schemalaggningar">Visa alla schemaläggningar</router-link>
        <router-link tag="li" to="/schemalaggningar/ny">Skapa ny schemaläggning</router-link>
      </ul>
      <div class="clear"></div>
    </div>
    
    <info-view v-if="!schedules.length">
      <img src="../assets/nexa/schemalaggningar_svart.png" style="margin-bottom:1em;">
      <h3>Du har inte schemalagt något än...</h3>
      <div>Schemaläggningar låter dig exempelvis tända eller släcka enheter baserat på en specifik tidpunkt eller vid soluppgång samt solnedgång.</div>
      <button @click="add" style="margin-top:2em;">Skapa en schemaläggning</button>
    </info-view>

    <table v-if="schedules.length">
      <thead>
        <tr>
          <th>Namn</th>
          <th></th>
          <th align="right">Aktiverad</th>
        </tr>
      </thead>
      
      <tbody>
        <tr v-for="schedule in schedules" :class="{ disabled: !schedule.enabled }">
          <td @click="edit(schedule.id)">
            <div>{{ schedule.name }}</div>
            <div style="font-size:11px;color:#9e9e9e;">
              <span v-if="schedule.enabled">{{ convertActiveDays(schedule) }}</span>
              <span v-else>Pausad</span>
            </div>
          </td>
          <td v-if="schedule.triggerType === 'TimeTrigger'">Specifik tid ({{ leftPad(schedule.time.hour) }}:{{ leftPad(schedule.time.minute) }})</td>
          <td v-if="schedule.triggerType === 'SunTrigger'">{{ sunTypeToLang[schedule.sunType.toLowerCase()] }}<span v-if="schedule.enabled && schedule.nextRun"> ({{ schedule.nextRun | moment("HH:mm") }})</span></td>
          <td align="right">
            <input type="checkbox" v-model="schedule.enabled" @change="toggleEnable(schedule)">
          </td>
        </tr>
      </tbody>
    </table>  
  </div>
</template>

<script>
  import { HTTP } from '../http.js'
  import infoView from './views/infoView'

export default {
  name: 'schemalaggningar',
  components: {
    infoView
  },
  data () {
    return {
      sunTypeToLang: {
        sunrise : 'Soluppgång',
        sunset: 'Solnedgång'
      }
    }
  },
  created () {},
  methods: {
    add () {
      this.$router.push({
        name: 'schemalaggningar_ny'
      })
    },
    
    edit (id) {
      this.$router.push({
        name: 'schemalaggningar_edit',
        params: {
          id: id
        }
      })
    },

    toggleEnable (schedule) {
      delete schedule.saving
      HTTP.post('triggers/' + schedule.id, schedule)
      .then(res => res.data)
      .then(json => {
      })
    },
    
    convertActiveDays (schedule) {
      const names = ['måndag', 'tisdag', 'onsdag', 'torsdag', 'fredag', 'lördag', 'söndag']

      if (schedule.triggerType === 'TimeTrigger') {
        let i
        let days2 = []
        for (i = 0; i < schedule.activeDays.length; i++) {
          if (schedule.activeDays[i]) {
            days2.push(names[i])
          }
        }
  
        return days2.length === 7 ? 'alla dagar i veckan' : days2.join(', ')
      } else {
        if ('condition' in schedule && '$is' in schedule.condition) {
          let days = schedule.condition['$is'].replace('globals.dayIs(', '').replace(')', '').trim()        
          const d = days.split(',').map(day => names[parseInt(day)])
          
          return d.length === 7 ? 'alla dagar i veckan' : d.join(', ')
        } else {
          return 'inga dagar valda'
        }
      }
    },
    
    rightPad (value) {
      return value < 10 ? value + '0' : value
    },
    
    leftPad (value) {
      return value < 10 ?  '0' + value : value
    }
  },
  
  computed: {
    schedules () {
      const include = ['TimeTrigger', 'SunTrigger']

      return this.$root.data.triggers.filter(trigger => include.some(v => trigger.triggerType === v)).map(schedule => {
        schedule.saving = false
        return schedule
      })
    }
  }
}
</script>

<style>  .disabled {
    color:#d2d2d2;
    text-decoration: line-through;
  }
</style>


// WEBPACK FOOTER //
// src/components/schemalaggningar.vue